/**
 * Possible values for the "who's paying" field. This is not part of the data
 * that will be sent to the server, but will affect how the request is generated.
 */
export const me = 'me';
export const other = 'other';
